import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { formatDate } from "./expeditionDetail.utils";

export const DeliveryFromDateAlert = ({
  expedition,
}: {
  expedition: GetOneExpeditionBoResponseDto;
}) => {
  const { t } = useTranslation(["boExpeditions", "common"]);
  const from = expedition.deliveryInfo?.deliveryFromDate;
  if (!from) return null;

  const isExpress = expedition.expeditionOptions?.express;
  const formattedDate = formatDate(from);

  return (
    <div className="w-full rounded-lg border border-blue-500 bg-blue-50 px-4 py-3 text-sm text-blue-700">
      <span className="font-medium">
        {isExpress
          ? t("expeditionDrawer.deliveryFromExpress", { date: formattedDate })
          : t("expeditionDrawer.deliveryFrom", { date: formattedDate })}
      </span>
    </div>
  );
};

export const CommentAlert = ({ expedition }: { expedition: GetOneExpeditionBoResponseDto }) => {
  const comment = expedition.deliveryInfo?.comment;

  if (!comment) return null;

  return (
    <div className="w-full cursor-default rounded-md bg-gray-200 p-2">
      <p className="text-[.875rem] whitespace-normal text-gray-700">
        <MessageCircle className="mr-1 inline-block h-4 w-4 shrink-0 align-text-top text-gray-500" />
        {comment}
      </p>
    </div>
  );
};
